interface CheckInOutNoteProps {
  isDe: boolean;
  className?: string;
}

/**
 * Standard check-in / check-out note shown wherever guests pick dates,
 * so the same wording appears consistently across booking and availability views.
 */
export default function CheckInOutNote({ isDe, className = "" }: CheckInOutNoteProps) {
  return (
    <p className={`flex items-start gap-2 text-xs text-foreground-600 ${className}`}>
      <i className="ri-time-line text-accent-600 mt-0.5"></i>
      <span>
        {isDe
          ? "Check-out: 12:00 · Check-in: 15:00 · (bei Verfügbarkeit jederzeit)"
          : "Check-out: 12:00 · Check-in: 15:00 · (anytime subject to availability)"}
      </span>
    </p>
  );
}